export default __webpack_public_path__ + "static/media/logo-rethink.f14161ad.png";